import store from '@/store';

const addToVueInstance = (Vue) => {
  Vue.prototype.$hasPermissionAsync = (permissionKey) => new Promise((resolve, reject) => {
    store.dispatch({ type: 'StaffStore/staffPermissions/loadPermission', permissionKey }, { root: true })
      .then((permissionData) => {
        resolve(permissionData.allow);
      })
      .catch((error) => {
        console.error('Error checking permission:', error);
        reject(error);
      });
  });

  Vue.prototype.$hasPermissionsAsync = (permissionKeys) => new Promise((resolve, reject) => {
    store.dispatch('StaffStore/staffPermissions/loadPermissions', { permissionKeys }, { root: true })
      .then((permissionData) => {
        const permissionMap = permissionData.reduce((acc, currentValue) => {
          acc[currentValue.key] = currentValue.allow;
          return acc;
        }, {});

        resolve(permissionMap);
      })
      .catch((error) => {
        console.error('Error checking permissions:', error);
        reject(error);
      });
  });
};

export default {
  addToVueInstance,
};
